var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteChatIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489",
    transform: "translate(-1064 -224)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_826",
    "data-name": "Rectangle 826",
    width: 14,
    height: 14,
    transform: "translate(1064 224)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    transform: "translate(1065.103 224.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M3,6H14.5",
    transform: "translate(-3 -3.444)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M13.946,4.556V13.5a1.278,1.278,0,0,1-1.278,1.278H6.278A1.278,1.278,0,0,1,5,13.5V4.556m1.917,0V3.278A1.278,1.278,0,0,1,8.195,2h2.556a1.278,1.278,0,0,1,1.278,1.278V4.556",
    transform: "translate(-3.722 -2)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    y2: 4.564,
    transform: "translate(4.564 5.477)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    y2: 4.564,
    transform: "translate(7.303 5.477)",
    fill: "none",
    stroke: "#5f636b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteChatIcon);
export default __webpack_public_path__ + "static/media/delete-chat-icon.ae13b2c121b8ccd4ccdcaeaa6235f9aa.svg";
export { ForwardRef as ReactComponent };